<script>
  import Avatar from '@components/Avatar.svelte';
  import DisplayName from '@components/DisplayName.svelte';
  import Username from '@components/Username.svelte';

  export let mobile = false;
  export let users = []; // Now passed from parent
  export let loading = false; // Optional: can be controlled by parent
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .referral-list {
    list-style: none;
    height: 508px;
    overflow: auto;
    margin-bottom: 0px;
  }

  .header-row {
    display: grid;
    grid-template-columns: 2fr repeat(5, 1fr);
    padding: 10px 0;
    border-bottom: 1px solid $neutral-input-gray;
    margin-bottom: 10px;
  }

  .header-cell {
    @include typeface-b2($font-weight-bold);
    color: $neutral-gray;
  }

  .user-row {
    display: grid;
    grid-template-columns: 2fr repeat(5, 1fr);
    align-items: center;
    padding: 10px 0;
  }

  .user-info-container {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      .name {
        color: $dark-blue;
      }
    }
  }

  .user-info {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
  }

  .cell-text {
    @include typeface-b2($font-weight-medium);
    color: $black;
  }

  .cell-text a {
    color: $dark-blue;
    text-decoration: none;
    padding: 5px 8px;
    margin: -5px -8px;
    border-radius: 4px;

    &:hover {
      text-decoration: underline;
      background-color: rgba($dark-blue, 0.05);
    }
  }

  .modal__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 45px;
  }

  .modal__title {
    width: 100%;
    margin-top: 24px;
    margin-bottom: 0;
    color: black;
    box-sizing: border-box;
    text-align: center;
  }

  .flex-item {
    display: flex;
  }
  .user-info {
    flex-direction: column;
    margin-left: 15px;
    vertical-align: middle;
    justify-content: center;
    margin-right: 30px;
  }
</style>

<div class:mobile={mobile}>
  <div class="referral-list purple-scrollbar">
    <div class="header-row">
      <div class="header-cell">User</div>
      <div class="header-cell">Date Joined</div>
      <div class="header-cell">Recs Added</div>
      <div class="header-cell">Optimized Lists</div>
      <div class="header-cell">Referrals</div>
      <div class="header-cell">Conversions</div>
    </div>
    {#if loading}
      <div class="loading-wrapper">
        <div class="loading">
          <i class="fa fa-spin fa-spinner" />
        </div>
      </div>
    {:else}
      {#each users as user}
        <div class="user-row">
          <div class="user-info-container">
            <a
              on:click={() => window.open(user.profile_path, mobile ? '_self' : '_blank')}
              class="flex-item left-side"
              href={user.profile_path}
              target={mobile ? '_self' : '_blank'}>
              <Avatar src={user.avatar_url} width={40} user={user} mobile={mobile} />
              <div class="flex-item user-info">
                <DisplayName user={user} mobile={mobile} />
                <Username user={user} mobile={mobile} />
              </div>
            </a>
          </div>
          <div class="cell-text">{user.date_joined}</div>
          <div class="cell-text">{user.recs_added}</div>
          <div class="cell-text">{user.lists_with_optimized_badge}</div>
          <div class="cell-text">
            {#if user.number_of_signups_using_code > 0}
              <a
                href="{user.profile_path}?admin_show_referral=true"
                target={mobile ? '_self' : '_blank'}
                on:click|stopPropagation={() => {}}>
                {user.number_of_signups_using_code}
              </a>
            {:else}
              {user.number_of_signups_using_code}
            {/if}
          </div>
          <div class="cell-text">
            {#if user.number_of_conversions > 0}
              <a
                href="{user.profile_path}?admin_show_conversions=true"
                target={mobile ? '_self' : '_blank'}
                on:click|stopPropagation={() => {}}>
                {user.number_of_conversions}
              </a>
            {:else}
              {user.number_of_conversions}
            {/if}
          </div>
        </div>
      {/each}
    {/if}
  </div>
</div>
